import styled from "styled-components";

export const StyledButton = styled.button`
  box-sizing: border-box;
  background-color: transparent;
  border: none;
  width: 24px;
  height: 24px;
  padding: 0;
  transition-property: opacity;
  transition-delay: 0s;
  transition-duration: 0.2s;
  transition-timing-function: ease;
  cursor: pointer;
  &:hover {
    opacity: 0.3;
  }
`;
